import { useCallback, useMemo } from "react";
import { useQueryState } from "./useQueryState";
import { getFilterQueryParamName } from "./const";

const FILTER_TYPE = { DISEASE: "disease", AGENT: "agent" };
const GET_RELATED_ITEMS = {
  [FILTER_TYPE.DISEASE]: (regimen) => [{ name: regimen.diseaseName }],
  [FILTER_TYPE.AGENT]: (regimen) => regimen.relatedAgents,
};

const collectFilterOptions = (regimens, filterType) => {
  const getRelatedItems = GET_RELATED_ITEMS[filterType];

  const optionsMap = regimens.reduce((acc, regimen) => {
    const collectOptions = (regimen) => {
      const relatedItems = getRelatedItems(regimen);
      relatedItems.forEach((item) => {
        acc[item.name] = true;
      });
    };

    if (regimen.subRegimens) {
      regimen.subRegimens.forEach(collectOptions);
    } else {
      collectOptions(regimen);
    }

    return acc;
  }, {});

  return Object.keys(optionsMap);
};

export const useRegimenFilter = ({
  regimens,
  filterType,
  logFilterUpdated,
}) => {
  const [selectedFilterOption, setSelectedFilterOption] = useQueryState(
    getFilterQueryParamName(filterType),
    ""
  );

  const filterOptions = useMemo(
    () => collectFilterOptions(regimens, filterType),
    [regimens, filterType]
  );

  const handleFilterChange = useCallback(
    (value) => {
      setSelectedFilterOption(value);
      logFilterUpdated({ value, filterType });
    },
    [logFilterUpdated, setSelectedFilterOption, filterType]
  );

  return {
    selectedFilterOption,
    setSelectedFilterOption: handleFilterChange,
    filterOptions,
  };
};
